// App.js
import React, { useState, useEffect ,useRef, useCallback } from 'react';
import './webprofile.css';
import Slider from "react-slick";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay,Navigation, Pagination, EffectCoverflow ,Zoom} from 'swiper/modules'; 
import { Alert, Button, TextInput } from 'evergreen-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram,faWhatsapp, faGoogle, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope,faPhone,faUserAlt } from '@fortawesome/free-solid-svg-icons'; // Email icon from solid
import 'swiper/css'; // This imports the core styles
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import { Helmet, HelmetProvider } from "react-helmet-async";
import Black_Geometric_Silver_Intricate_Sleeve from './Black_Geometric_Silver_Intricate_Sleeve.png'
import Black_Floral_Gold_Intricate_Sleeve from './Black_Floral_Gold_Intricate_Sleeve.png'
import Black_Floral_Silver_Intricate_Sleeve from './Black_Floral_Silver_Intricate_Sleeve.png'
import Black_Geometric_Gold_Intricate_Sleeve from './Black_Geometric_Gold_Intricate_Sleeve.png'
import Silver_Geometric_Silver_Intricate_Sleeve from './Silver_Geometric_Silver_Intricate_Sleeve.png'
import Silver_Floral_Gold_Intricate_Sleeve from './Silver_Floral_Gold_Intricate_Sleeve.png'
import Silver_Floral_Silver_Intricate_Sleeve from './Silver_Floral_Silver_Intricate_Sleeve.png'
import Silver_Geometric_Gold_Intricate_Sleeve from './Silver_Geometric_Gold_Intricate_Sleeve.png'
import goldeisimg from '../pages/jiffygoldies_o_web.png'
import {
    BrowserRouter as Router,
    Link,
    Route,
    Routes,
    useParams,
  } from "react-router-dom";
import axios from "axios";
import userimg from '../pages/user_plain.png'
import { motion, useInView } from 'framer-motion';

const Section = ({ children, animation = 'fade', className }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, );

  const getAnimationVariants = useCallback(() => {
      switch (animation) {
          case 'fade':
              return {
                  hidden: { opacity: 0 },
                  visible: { opacity: 1, transition: { duration: 0.8, ease: "easeInOut",delay: 0.6 } },
              };
          case 'slide-left':
              return {
                  hidden: { opacity: 0, x: -50 },
                  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeInOut",delay:0.6 } },
              };
          case 'slide-right':
              return {
                  hidden: { opacity: 0, x: 50 },
                  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeInOut",delay:0.6 } },
              };
          case 'zoom':
              return {
                  hidden: { opacity: 0, scale: 0.8 },
                  visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeInOut",delay:0.6 } },
              };  
              case 'scale-up': 
              return {
                hidden: { opacity: 1, scale: 1 }, // Starts at full size and visible
                visible: { opacity: 1, scale: 1.05, transition: {  duration: 0.8, ease: "easeInOut",delay:0.6} }, // Scales up to 105%
            };
          case 'none':
              return {
                  hidden: {},
                  visible: {},
              };
          default:
              return {
                  hidden: { opacity: 0 },
                  visible: { opacity: 1, transition: { duration: 0.8, ease: "easeInOut" } },
              };
      }
  }, [animation]);

  const variants = getAnimationVariants();

  // Replaced cn with simple string concatenation
  const sectionClasses = `py-16 text-center ${className || ''}`;

  return (
      <motion.section
          ref={ref}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={variants}
          className={sectionClasses}
      >
          {children}
      </motion.section>
  );
};

// Install the modules

const App = (data) => {
  
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobileScreen = screenWidth <= 768; 
  const imageContainerRef = useRef(null);
  const [fetcheddata, setData] = useState([]);
  const [bannerUrl, setBannerUrl] = useState('');
  const [scroll, setScroll] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [headerlogo,setheaderlogo]=useState('')
  const [section2header,setsection2header]=useState('')
  const [para2text,setpara2text]=useState('')
  const [section3image,setsection3image]=useState('')
  const [section4header,setsection4header]=useState('')
  const [section4para,setsection4para]=useState('')
  const [section5,setsection5]=useState([])
  const [section6,setsection6]=useState('')
  const [tagline,settagline]=useState('')
  const [email,setemail]=useState('')
  const [imageload,setimageload]=useState(false)
  const [buttontext,setButtontext]=useState('Register')
  const [errormessage,setErrormessage]=useState('')
  const [thanksview,setthanksview]=useState(false)
  const [mailbody,setmailbody]=useState('')
  const [consumermailbody,setconsumermailbody]=useState('')
  const [favoritesmailbody,setfavoritesmailbody]=useState('')
  const [businessname, setbusinessname] = useState("");
const [businesslogo, setbusinesslogo] = useState("");
const [businessprofile, setbusinessprofile] = useState("");
const [busphone,setbusphone]=useState('')
const [successalert,setsuccessalert]=useState(false)
const { id } = useParams();
const [countrycode,setcountrycode] = useState('');
const [BID256,setBID256]=useState('')
const [headerbackgroundcolor,setheaderbackgroundcolor]=useState('')
const [headeronscrollbackgroundcolor,setheaderonscrollbackgroundcolor]=useState('')
const [section1,setsection1]=useState('')
const [section1backgroundcolor,setsection1backgroundcolor]=useState('')
const [section1headerfont,setsection1headerfont]=useState('')
const [section1animation,setsection1animation]=useState('')
const [section2animation,setsection2animation]=useState('')
const [section4animation,setsection4animation]=useState('')
const [section5animation,setsection5animation]=useState('')
const [section6animation,setsection6animation]=useState('')
const [section7animation,setsection7animation]=useState('')
const [section1headerfontcolor,setsection1headerfontcolor]=useState('')
const [section1headerfontcoloronscroll,setsection1headerfontcoloronscroll]=useState('')
const [section1headerfontsize,setsection1headerfontsize]=useState('')
const [section2background,setsection2background]=useState('')
const [section2headerfont,setsection2headerfont]=useState('')
const [section2headerfontsize,setsection2headerfontsize]=useState('')
const [section2parafontsize,setsection2parafontsize]=useState('')
const [section2headerfontcolor,setsection2headerfontcolor]=useState('')
const [section2parafont,setsection2parafont ]=useState('')
const [section2parafontcolor,setsection2parafontcolor]=useState('')
const [section3backgroundcolor,setsection3backgroundcolor]=useState('')
const [section4headerfont,setsection4headerfont]=useState('')
const [section4headerfontcolor,setsection4headerfontcolor]=useState('')
const [section4headerfontsize,setsection4headerfontsize]=useState('')
const [section4parafont,setsection4parafont]=useState('')
const [section4paracolor,setsection4paracolor]=useState('')
const [section4parafontsize,setsection4parafontsize]=useState('')
const [section5backgroundcolor,setsection5backgroundcolor]=useState('')
const [section5headerfont,setsection5headerfont]=useState('')
const [section5headerfontsize,setsection5headerfontsize]=useState('')
const [section5headercolor,setsection5headercolor]=useState('')
const [section6headerfont,setsection6headerfont]=useState('')
const [section6headercolor,setsection6headercolor]=useState('')
const [section6headerfontsize,setsection6headerfontsize]=useState('')
const [section6parafont,setsection6parafont]=useState('')
const [section6parafontsize,setsection6parafontsize]=useState('')
const [section6paracolor,setsection6paracolor]=useState('')
const [section7,setsection7]=useState('')
const [section7background,setsection7background]=useState('')
const [section7font,setsection7font]=useState('')
const [section7fontcolor,setsection7fontcolor]=useState()
const [section7fontsize,setsection7fontsize]=useState('')
const [regheader,setregheader]=useState('')
const [regtext,setregtext]=useState('')
const [headerfontsize,setheaderfontsize]=useState('')
const [regheaderfontsize,setregheaderfontsize]=useState('')
const [regtextfontsize,setregtextfontsize]=useState('')
const [titlelogo,settitlelogo]=useState('')
const [title,settitle]=useState('')
const [webdescription,setwebdescription]=useState('')
const [referalcode,setreferalcode]=useState('')
const [referalcodeinput,setreferalcodeinput]=useState(false)
const [section8background,setsection8background]=useState('')
const [section8headercolor,setsection8headercolor]=useState('')
const [section8headerfont,setsection8headerfont]=useState('')
const [section8parafont,setsection8parafont]=useState('')
const [section8paracolor,setsection8paracolor]=useState('')
const [section8reftextcolor,setsection8reftextcolor]=useState('')
const [dynamicmanifest,setdynamicmanifest]=useState('')
const [section8invitetext,setsection8invitetext]=useState('')
const [section8invitepara,setsection8invitepara]=useState('')
const [section8invitefont,setsection8invitefont]=useState('')
const [section8invitefontsize,setsection8invitefontsize]=useState('')
const [section8invitetextcolor,setsection8invitetextcolor]=useState('')
const [section8footertext,setsection8footertext]=useState('')
const [section8footerfontsize,setsection8footerfontsize]=useState('')
const [section8footerfont,setsection8footerfont]=useState('')
const [section8footertextcolor,setsection8footertextcolor]=useState('')
const [section8inviteparafont,setsection8inviteparafont]=useState('')
const [section8inviteparafontsize,setsection8inviteparafontsize]=useState('')
const [section8inviteparacolor,setsection8inviteparacolor]=useState('')
const [section9,setsection9]=useState('')
const [demosectionstatus,setdemosectionstatus]=useState('')
const [demosectionbuttontext,setdemosectionbuttontext]=useState('')
const [demosectionbuttontextcolor,setdemosectionbuttontextcolor]=useState('')
const [demosectionbuttontextfontsize,setdemosectionbuttontextfontsize]=useState('')
const [demosectionbuttontextfont,setdemosectionbuttontextfont]=useState('')
const [demosectionbuttoncolor,setdemosectionbuttoncolor]=useState('')
const [demosectionheader,setdemosectionheader]=useState('')
const [demosectionheaderfont,setdemosectionheaderfont]=useState('')
const [demosectionheaderfontsize,setdemosectionheaderfontsize]=useState('')
const [demosectionheadercolor,setdemosectionheadercolor]=useState('')
const [busmail,setbusmail]=useState('') 
const [showPopup, setShowPopup] = useState(false);
const [keywords,setkeywords]=useState('')
const [embedHtml, setEmbedHtml] = useState('');
const [section1headertext,setsection1headertext]=useState('')
const [section1paratext,setsection1paratext]=useState('')
const [offerstatus,setofferstatus]=useState('InActive')
const [offerlink,setofferlink]=useState('') 
const [fabricColor, setFabricColor] = useState('');
const [embroideryType, setEmbroideryType] = useState('');
const [embroideryColor, setEmbroideryColor] = useState('');
const [designIdea, setDesignIdea] = useState('');
const [embroideryPosition, setEmbroideryPosition] = useState('');
const [generatedImage, setGeneratedImage] = useState(''); // State to hold the hardcoded image URL
const [activeStep, setActiveStep] = useState(0); // New state to track the active selection step
const [showDemoContent, setShowDemoContent] = useState(false);
const [mobileBannerVideoUrl,setmobileBannerVideoUrl] = useState(''); // Placeholder for mobile video
const [laptopBannerVideoUrl,setlaptopBannerVideoUrl] =useState('');
const [currentBannerSource,setcurrentBannerSource]=useState('');

// Mock data for dropdown options - NOW LIMITED TO TWO AND WITH COLOR CODES
const fabricColorsOptions = [
  { name: 'Black', hex: '#000000' }, // Changed to Black with hex code
  { name: 'Silver', hex: '#C0C0C0' } 
];
const embroideryTypesOptions = ['Floral', 'Geometric'];
const embroideryColorsOptions = [
    { name: 'Gold', hex: '#FFD700' },
    { name: 'Silver', hex: '#C0C0C0' }
];
const designIdeasOptions = [ 'Intricate'];
const embroideryPositionsOptions = [ 'Sleeve'];
const specificDesignImages = {
 'Black_Floral_Gold_Intricate_Sleeve': Black_Floral_Gold_Intricate_Sleeve,
  'Black_Floral_Silver_Intricate_Sleeve': Black_Floral_Silver_Intricate_Sleeve,
 'Black_Geometric_Gold_Intricate_Sleeve': Black_Geometric_Gold_Intricate_Sleeve,
 'Black_Geometric_Silver_Intricate_Sleeve': Black_Geometric_Silver_Intricate_Sleeve,
 'Silver_Floral_Gold_Intricate_Sleeve': Silver_Floral_Gold_Intricate_Sleeve,
'Silver_Floral_Silver_Intricate_Sleeve': Silver_Floral_Silver_Intricate_Sleeve,
 'Silver_Geometric_Gold_Intricate_Sleeve': Silver_Geometric_Gold_Intricate_Sleeve,
 'Silver_Geometric_Silver_Intricate_Sleeve': Silver_Geometric_Silver_Intricate_Sleeve,
};

// Handler for the Generate button
const handleGenerateDesign = () => {
  // Create a key from the current selections
  const selectedOptionsKey = `${fabricColor}_${embroideryType}_${embroideryColor}_${designIdea}_${embroideryPosition}`;

  // Get the hardcoded image URL for this specific combination
  const imageUrl = specificDesignImages[selectedOptionsKey];

  console.log('Generating design with:', {
      fabricColor, embroideryType, embroideryColor, designIdea, embroideryPosition
  });
  console.log(selectedOptionsKey,imageUrl)
  setGeneratedImage(imageUrl);
  setActiveStep(5); // Move to a "finished" state after generation
  if (imageContainerRef.current) {
    imageContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
};
const handleOptionSelect = (setter, value, currentStep, nextStep) => {
  setter(value);
  if (activeStep === currentStep) {
      setActiveStep(nextStep);
  }
};
const isVideoUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi']; // Common video extensions
  const lowerCaseUrl = url.toLowerCase();
  console.log('is video?',videoExtensions.some(ext => lowerCaseUrl.includes(ext)))
  return videoExtensions.some(ext => lowerCaseUrl.includes(ext));
};
const isGenerateButtonEnabled = fabricColor && embroideryType && embroideryColor && designIdea && embroideryPosition;

// Handler for the Generate button
/*const handleGenerateDesign = () => {
    // In a real application, you'd send these selections to a backend
    // to generate a dynamic image. For this demo, we just show a hardcoded one.
    console.log('Generating design with:', {
        fabricColor, embroideryType, embroideryColor, designIdea, embroideryPosition
    });
    setGeneratedImage(hardcodedImageUrl);
};*/
// --- End New Demo Section States ---



function referalcodeinputview(){
  setreferalcodeinput(true)
}
function onemailchange(e){
    setErrormessage('')
    setsuccessalert(false)
  setemail(e.target.value)}
  function onreferallcodechange(e){
    setreferalcode(e.target.value)
  }
  function onemailend (e) {
    setErrormessage('')
    setemail(e.target.value)
    //validateEmail(e.target.value)
    
    if(email!=''){
        if(!validateEmail(e.target.value)){
          setErrormessage('Invalid')
        }
        else{
          setemail(e.target.value)
        }
       }
      }
  
  function  validateEmail (email){
    setErrormessage('')
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
  
    }
  function submit() {
      
     if(email==''){
    setErrormessage('Email required')
     } 
     else if(errormessage==''){
      var posturl='';
      setButtontext("Registering")
      if(countrycode=='IN'){
        posturl='https://us-central1-jiffybook-india.cloudfunctions.net/Consumercommunityreg'
      }
      else if(countrycode=='EE'){
        posturl='https://us-central1-jiffybook-app.cloudfunctions.net/Consumercommunityreg'
         
      }
      axios({
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          //url:'https://us-central1-jiffybook-preprod.cloudfunctions.net/Consumercommunityreg',
          url:posturl,
          //url:'https://us-central1-jiffybook-india-preprod.cloudfunctions.net/Consumercommunityreg',
          data:{
            CMail:email,
            CPhone:countrycode+busphone,
            Bid:BID256,
            Bname:businessname,
            strBlogo:businesslogo,
            strBprofileimage:businessprofile,
            strBname:businessname,
            strCouponCode:referalcode.toLocaleUpperCase()

  
          },
        
        }).then(
          setTimeout(function(){
            setsuccessalert(true)
            setButtontext('Sending')
         // window.location.href='https://preprod-gallery-profile.web.app/Profile/'+BID256
            },2000),
            setTimeout(function(){
           setemail('')
           setButtontext(fetcheddata.data.section8.Registerbuttontext)
           //setsuccessalert(false)
           setreferalcode('')
           setreferalcodeinput(false)
              },4000),
            console.log('posted')
          )
            
  
      }
    }
  
    const handleCampaignRedirect = () => {
      window.location.href = offerlink;
  };
    const handleRedirect = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
      // Detect iOS devices (iPhone, iPad, iPod)
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href = 'https://apps.apple.com/app/id1514749994';
      } 
      // Detect Android devices
      else if (/android/i.test(userAgent)) {
        window.location.href = 'https://play.google.com/store/apps/details?id=com.indreamer.jiffybook';
      } 
      // Fallback for other devices
      else {
        setShowPopup(true)

      }
    };
    useEffect(() => {
      const handleResize = () => {
          setScreenWidth(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
   
  setData(data)
  //console.log('thedatin',data)
    const fetchData = async (data) => {
      try {
        
  //console.log('thedatn',fetcheddata)
      
        
        const combinedArray = Object.keys(fetcheddata.data.section5.Images).map(key => ({
            id: key,
            url: fetcheddata.data.section5.Images[key],
            text: fetcheddata.data.section5.ImageText[key]
          }));
        const swipearray=Object.keys(fetcheddata.data.section7.Images).map(key => ({
            id: key,
            url: fetcheddata.data.section7.Images[key],
            text: fetcheddata.data.section7.ImageText[key]
          }));
          if(fetcheddata.data.section9.Instagramsection.Embedcode!=''){
          setEmbedHtml(fetcheddata.data.section9.Instagramsection.Embedcode);
          }

          // This part is crucial for Instagram's embed script to work
          // It re-runs the Instagram embed script to render the blockquote
          if (window.instgrm) {
              window.instgrm.Embeds.process();
          } else {
              const script = document.createElement('script');
              script.async = true;
              script.src = '//www.instagram.com/embed.js';
              script.onload = () => {
                  if (window.instgrm) {
                      window.instgrm.Embeds.process();
                  }
              };
              document.body.appendChild(script);
          }
          setcountrycode(fetcheddata.data.countrycode)
          setBID256(fetcheddata.data.BID256)
        setBannerUrl(fetcheddata.data.section1.Coverimage);
        setbusinessname(fetcheddata.data.busname)
        setbusinessprofile(fetcheddata.data.busprofile)
        setbusinesslogo(fetcheddata.data.buslogo)
          setheaderbackgroundcolor(fetcheddata.data.section1.Headerdefaultbackground)
          setheaderonscrollbackgroundcolor(fetcheddata.data.section1.Headerbackgroundonscroll)
          setsection1backgroundcolor(fetcheddata.data.section1.Backgroundcolor)
        setheaderlogo(fetcheddata.data.section1.Headerlogo) // Assuming result.bannerUrl contains the banner URL
        setsection2header(fetcheddata.data.section2.Heading2text)
        setpara2text(fetcheddata.data.section2.Para2text)
        setsection3image(fetcheddata.data.section3.Imageurl)
        setsection4header(fetcheddata.data.section4.Headertext)
        setsection4para(fetcheddata.data.section4.Paratext)
        setsection6(fetcheddata.data.section6)
        settagline(fetcheddata.data.section1.Tagline)
        setsection1headerfont(fetcheddata.data.section1.Font)
        setsection1headerfontcolor(fetcheddata.data.section1.Fontcolor)
        setsection1headerfontcoloronscroll(fetcheddata.data.section1.Fontcoloronscroll)
        setsection1headerfontsize(fetcheddata.data.section1.Fontsize)
        setsection1animation(fetcheddata.data.section1.Animation)
        setsection2animation(fetcheddata.data.section2.Animation)
        setsection4animation(fetcheddata.data.section4.Animation)
        setsection5animation(fetcheddata.data.section5.Animation)
        setsection6animation(fetcheddata.data.section6.Animation)
        setsection7animation(fetcheddata.data.section7.Animation)
        setsection2background(fetcheddata.data.section2.Backgroundcolor)
        setsection2headerfont(fetcheddata.data.section2.Headerfont)
        setsection2headerfontcolor(fetcheddata.data.section2.Headercolor)
        setsection2headerfontsize(fetcheddata.data.section2.Headerfontsize)
        setsection2parafontsize(fetcheddata.data.section2.Parafontsize)
        setsection2parafont(fetcheddata.data.section2.Parafont)
        setsection2parafontcolor(fetcheddata.data.section2.Paracolor)
        setsection3backgroundcolor(fetcheddata.data.section3.Backgroundcolor)
        setsection4headerfont(fetcheddata.data.section4.Headerfont)
        setsection4headerfontcolor(fetcheddata.data.section4.Headercolor)
        setsection4headerfontsize(fetcheddata.data.section4.Headerfontsize)
        setsection4parafont(fetcheddata.data.section4.Parafont)
        setsection4paracolor(fetcheddata.data.section4.Paracolor)
        setsection4parafontsize(fetcheddata.data.section4.Parafontsize)
        setsection5backgroundcolor(fetcheddata.data.section5.Backgroundcolor)
        setsection5headerfont(fetcheddata.data.section5.Headerfont)
        setsection5headerfontsize(fetcheddata.data.section5.Headerfontsize)
        setsection5headercolor(fetcheddata.data.section5.Headercolor)
        setsection6headerfont(fetcheddata.data.section6.Headerfont)
        setsection6headerfontsize(fetcheddata.data.section6.Headerfontsize)
        setsection6headercolor(fetcheddata.data.section6.Headercolor)
        setsection6parafont(fetcheddata.data.section6.Parafont)
        setsection6parafontsize(fetcheddata.data.section6.Parafontsize)
        setsection6paracolor(fetcheddata.data.section6.Paracolor)
        setsection7background(fetcheddata.data.section7.Backgroundcolor)
        setsection7font(fetcheddata.data.section7.Font)
        setsection7fontcolor(fetcheddata.data.section7.Fontcolor)
        setsection7fontsize(fetcheddata.data.section7.Fontsize)
        setregheader(fetcheddata.data.section8.Regheader)
        setregtext(fetcheddata.data.section8.Regtext)
        setheaderfontsize(fetcheddata.data.section1.Fontsize)
        setregheaderfontsize(fetcheddata.data.section8.Headerfontsize)
        setregtextfontsize(fetcheddata.data.section8.Parafontsize)
        settitlelogo(fetcheddata.data.section1.Titlelogo)
        settitle(fetcheddata.data.section1.Title)
        setsection8background(fetcheddata.data.section8.Backgroundcolor)
        setsection8reftextcolor(fetcheddata.data.section8.Referaltextcolor)
        setwebdescription(fetcheddata.data.section1.Headdata.description)
        setkeywords(fetcheddata.data.section1.Headdata.keywords)
        setsection8headercolor(fetcheddata.data.section8.Headercolor)
        setsection8headerfont(fetcheddata.data.section8.Headerfont)
        setsection8paracolor(fetcheddata.data.section8.Paracolor)
        setsection8parafont(fetcheddata.data.section8.Parafont)
        setsection8invitetext(fetcheddata.data.section8.Invitetext)
        setsection8invitepara(fetcheddata.data.section8.Invitepara)
        setsection8invitefontsize(fetcheddata.data.section8.Invitefontsize)
        setsection8invitefont(fetcheddata.data.section8.Invitefontfamily)
        setsection8invitetextcolor(fetcheddata.data.section8.Invitetextcolor)
        setsection8inviteparafont(fetcheddata.data.section8.Inviteparafontfamily)
        setsection8inviteparafontsize(fetcheddata.data.section8.Inviteparafontsize)
        setsection8inviteparacolor(fetcheddata.data.section8.Inviteparacolor)
        setsection8footertext(fetcheddata.data.section8.Footertext)
        setsection8footerfontsize(fetcheddata.data.section8.Footerfontsize)
        setsection8footerfont(fetcheddata.data.section8.Footerfontfamily)
        setsection8footertextcolor(fetcheddata.data.section8.Footertextcolor)
        setsection1headertext(fetcheddata.data.section1.Header)
        setsection1paratext(fetcheddata.data.section1.Paratext)
        setbusmail(fetcheddata.data.busmail)
        setsection9(fetcheddata.data.section9)
        setbusphone(fetcheddata.data.busphone)
        setsection1(fetcheddata.data.section1)
        setofferstatus(fetcheddata.data.section1.Offerstatus)
        setofferlink(fetcheddata.data.section1.Offerlink)
        setdemosectionstatus(fetcheddata.data.Demosection.Status)
        setdemosectionbuttoncolor(fetcheddata.data.Demosection.Buttoncolor)
        console.log('buttoncolor',demosectionbuttoncolor)
        setdemosectionbuttontext(fetcheddata.data.Demosection.Demobuttontext)
        setdemosectionbuttontextcolor(fetcheddata.data.Demosection.Buttontextcolor)
        setdemosectionbuttontextfont(fetcheddata.data.Demosection.Buttontextfont)
        setdemosectionbuttontextfontsize(fetcheddata.data.Demosection.Buttontextfontsize)
        setdemosectionheader(fetcheddata.data.Demosection.Demoheadertext)
        setdemosectionheadercolor(fetcheddata.data.Demosection.Headercolor)
        setdemosectionheaderfont(fetcheddata.data.Demosection.Headerfont)
        setdemosectionheaderfontsize(fetcheddata.data.Demosection.Headerfontsize)
        setmobileBannerVideoUrl(fetcheddata.data.section1.Covermobilevideo)
        setlaptopBannerVideoUrl(fetcheddata.data.section1.Covervideo)
        // Placeholder for laptop video (can be different)
        setcurrentBannerSource(isMobileScreen ? mobileBannerVideoUrl : laptopBannerVideoUrl);
//const isCurrentSourceVideo = isVideoUrl(currentBannerSource);
        //setButtontext(fetcheddata.data.section1.Registerbuttontext.)
       // console.log(section1headerfont.replace(/^"(.*)"$/, '$1'))
        document.title=fetcheddata.data.section1.Title;
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = fetcheddata.data.section1.Titlelogo;
      document.getElementsByTagName('head')[0].appendChild(link);
     const canonicallink= document.querySelector("link[rel*='canonical']") || document.createElement('link')
      canonicallink.href = fetcheddata.data.section1.Headdata.canonical;
      document.getElementsByTagName('head')[0].appendChild(canonicallink);
      setdynamicmanifest({
        "short_name": fetcheddata.data.section1.Title,
        "name": fetcheddata.data.section1.Title,
        "icons": [
          {
            "src": fetcheddata.data.section1.Titlelogo,
            "sizes": "64x64 32x32 24x24 16x16",
            "type": "image/x-icon"
          },
          {
            "src": fetcheddata.data.section1.Titlelogo,
            "type": "image/png",
            "sizes": "192x192"
          },
          {
            "src": fetcheddata.data.section1.Titlelogo,
            "type": "image/png",
            "sizes": "512x512"
          }
        ],
        "start_url": ".",
        "display": "standalone",
        "theme_color": "#000000",
        "background_color": "#ffffff"
      })
      
      const ogImageMeta = document.querySelector("meta[property='og:image']");
  if (ogImageMeta) {
    
    ogImageMeta.setAttribute("content", fetcheddata.data.section1.Headdata.ogimage);
  }
  const ogdescrtiption = document.querySelector("meta[property='og:description']");
  if (ogdescrtiption) {
    
    ogdescrtiption.setAttribute("content", fetcheddata.data.section1.Headdata.description);
  }
  const desc=document.querySelector("meta[name='description']");
  desc.setAttribute("content",fetcheddata.data.section1.Headdata.description)
  document.querySelector("meta[name='robots']").setAttribute("content",fetcheddata.data.section1.Headdata.robots)
  document.querySelector("meta[property='og:title']").setAttribute("content",fetcheddata.data.section1.Headdata.ogtitle)
  document.querySelector("meta[property='og:url']").setAttribute("content",fetcheddata.data.section1.Headdata.ogurl)
  document.querySelector("meta[property='og:type']").setAttribute("content",fetcheddata.data.section1.Headdata.ogtype)
  document.querySelector("meta[name='twitter:card']").setAttribute("content",fetcheddata.data.section1.Headdata.twittercard)
  document.querySelector("meta[name='twitter:title']").setAttribute("content",fetcheddata.data.section1.Headdata.twittertitle)
  document.querySelector("meta[name='twitter:description']").setAttribute("content",fetcheddata.data.section1.Headdata.twitterdescription)
  document.querySelector("meta[name='twitter:image']").setAttribute("content",fetcheddata.data.section1.Headdata.twitterimage)
  document.querySelector("meta[name='author']").setAttribute("content",fetcheddata.data.section1.Headdata.author)
  const appleTouchIconLink = document.getElementById("apple-touch-icon");
  if (appleTouchIconLink) {
    appleTouchIconLink.setAttribute("href", fetcheddata.data.section1.Titlelogo);
  }
  const defaulticon=document.getElementById("icon");
  if (defaulticon) {
    defaulticon.setAttribute("href", fetcheddata.data.section1.Titlelogo);
  }
  
  document.getElementsByTagName('head')[0].appendChild(link);     
  if(swipearray){
                
        setsection7(swipearray.sort((a, b) => a.id.localeCompare(b.id)))
        
       // console.log(section7)
        }
          if(combinedArray){
          setsection5(combinedArray.sort((a, b) => a.id.localeCompare(b.id)))
       // console.log(section5)
      }
      } catch (error) {
        console.error('Error fetchingdata:', error);
      }
    };

    fetchData(fetcheddata);
   
    const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
      };
  
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [data,fetcheddata]);
  
    if (!data) {
      return <div>Loading...</div>;
    }
  return (
    
    <div style={{ width: '100%', overflowX: 'hidden',  }}>
     
         <head>
         <meta property="og:image" content={titlelogo} />
          <meta property="og:title" content={title} />
  <meta property="og:description" content={webdescription} />
  <meta name="description" content={webdescription} />
  <meta name="keywords" content={keywords} />
  <meta name="author" content="AIRIN Luxury Fashion"/>
         <link rel="icon" href={titlelogo} />
         <link rel="apple-touch-icon" href={titlelogo} />
    <link rel="manifest" href={new Blob([JSON.stringify(dynamicmanifest)], {
      type: 'application/json',
    })} />
         <link href='https://fonts.googleapis.com/css?family=Great Vibes' rel='stylesheet'></link>
         <link href="https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&display=swap" rel="stylesheet"></link>
<link href="https://fonts.googleapis.com/css2?family=Sacramento&display=swap" rel="stylesheet"></link>
<link href="https://fonts.googleapis.com/css2?family=Alex+Brush&display=swap" rel="stylesheet"></link>
<link href="https://fonts.googleapis.com/css2?family=Lexend+Deca&display=swap" rel="stylesheet"></link>  
<link rel="preconnect" href="https://fonts.googleapis.com"></link>
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
<link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap" rel="stylesheet"></link>
      </head>

      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"/>

    <header className={`header ${isScrolled ? 'scrolled' : ''}`} 
    style={{backgroundColor:isScrolled?headeronscrollbackgroundcolor:headerbackgroundcolor,
    fontSize:headerfontsize,borderStyle:'none',height:"auto",fontWeight:'lighter'}}>
      <img src={headerlogo} alt="Logo" className="logo" />
      <h1 style={{fontWeight:'lighter',fontFamily:section1headerfont.replace(/^"(.*)"$/, '$1'),color:isScrolled?section1headerfontcoloronscroll:section1headerfontcolor,fontSize:section1headerfontsize,
      marginTop:-25}}>{tagline}</h1>
        
    </header>
    <Section animation={section1animation}>
      
      {!mobileBannerVideoUrl&&!laptopBannerVideoUrl?(
    <div style={{backgroundColor:section2background,animation:'fade'}}>
    <div  style={{ //backgroundImage: `url(${bannerUrl})`,
    backgroundColor:section2background,width:'100%' }}>
     <img className="banner" src={bannerUrl?bannerUrl:null}>
     </img>
     <div 
    className="section6text" 
    style={{
      position: 'absolute', 
      bottom: '20px',  // Positioning 20px above the bottom
      left: '20%',    // Positioning 20px from the left edge
     // color: section6headercolor,
      padding: '10px'  // Optional: Add padding around the text
    }}
  >
    {offerstatus=='InActive'&&fetcheddata.data?(
      <div style={{marginBottom:90}}>
    <h2 style={{ fontFamily: fetcheddata.data.section1.Headerfont, fontSize: fetcheddata.data.section1.Headerfontsize,color:fetcheddata.data.section1.Headercolor }}>
      {section1headertext}
    </h2>
    <p style={{ fontFamily: fetcheddata.data.section1.Parafont, fontSize: fetcheddata.data.section1.Parafontsize, color: fetcheddata.data.section1.Paracolor }}>
     {section1paratext}
    </p>
    </div>):null}
    {offerstatus=='Active'&&fetcheddata.data?(
      <div style={{marginBottom:90}}>
    <h2 style={{ fontFamily: fetcheddata.data.section1.Headerfont, fontSize: fetcheddata.data.section1.Headerfontsize,
      color:fetcheddata.data.section1.Headercolor,
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      textShadow: '3px 3px 6px rgba(255, 255, 255, 0.7)' }}>
      {section1headertext}
    </h2>
    <a
           // onClick={handleCampaignRedirect}
            href={offerlink} // Add a fallback href, even if onClick handles navigation
            target="_blank" // Opens the link in a new tab
            rel="noopener noreferrer" // Security best practice for target="_blank"
            style={{
                fontFamily: fetcheddata.data.section1.Parafont,
                fontSize: fetcheddata.data.section1.Parafontsize,
                color: fetcheddata.data.section1.Paracolor,
                textDecoration: 'underline', // Makes the text underlined
                cursor: 'pointer',
            }}
        >
            {section1paratext}
        </a>
    </div>):null}
  </div>
    </div>
    </div>):(
       <div style={{backgroundColor:section2background,animation:'fade'}}>
       <div  style={{ //backgroundImage: `url(${bannerUrl})`,
       backgroundColor:section2background,width:'100%' }}>
          <video
                            className="banner" // Apply existing image class for styling
                            src={isMobileScreen?mobileBannerVideoUrl:laptopBannerVideoUrl}
                            autoPlay
                            loop
                            muted // Muted is often required for autoplay on many browsers
                            playsInline // Important for iOS to allow autoplay without full-screen
                            
                        >
                                Your browser does not support the video tag.
                            </video>
        <div 
       className="section6text" 
       style={{
         position: 'absolute', 
         bottom: '20px',  // Positioning 20px above the bottom
         left: '20%',    // Positioning 20px from the left edge
        // color: section6headercolor,
         padding: '10px'  // Optional: Add padding around the text
       }}
     >
       {offerstatus=='InActive'&&fetcheddata.data?(
         <div style={{marginBottom:90}}>
       <h2 style={{ fontFamily: fetcheddata.data.section1.Headerfont, fontSize: fetcheddata.data.section1.Headerfontsize,color:fetcheddata.data.section1.Headercolor }}>
         {section1headertext}
       </h2>
       <p style={{ fontFamily: fetcheddata.data.section1.Parafont, fontSize: fetcheddata.data.section1.Parafontsize, color: fetcheddata.data.section1.Paracolor }}>
        {section1paratext}
       </p>
       </div>):null}
       {offerstatus=='Active'&&fetcheddata.data?(
         <div style={{marginBottom:90}}>
       <h2 style={{ fontFamily: fetcheddata.data.section1.Headerfont, fontSize: fetcheddata.data.section1.Headerfontsize,
         color:fetcheddata.data.section1.Headercolor,
         boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
         textShadow: '3px 3px 6px rgba(255, 255, 255, 0.7)' }}>
         {section1headertext}
       </h2>
       <a
              // onClick={handleCampaignRedirect}
               href={offerlink} // Add a fallback href, even if onClick handles navigation
               target="_blank" // Opens the link in a new tab
               rel="noopener noreferrer" // Security best practice for target="_blank"
               style={{
                   fontFamily: fetcheddata.data.section1.Parafont,
                   fontSize: fetcheddata.data.section1.Parafontsize,
                   color: fetcheddata.data.section1.Paracolor,
                   textDecoration: 'underline', // Makes the text underlined
                   cursor: 'pointer',
               }}
           >
               {section1paratext}
           </a>
       </div>):null}
     </div>
       </div>
       </div>
    )}
    </Section>
    <div className="black-section" style={{backgroundColor:section2background,}}>
      <div className="black-section-text">
      <h1 style={{color:section2headerfontcolor,textAlign:'center',
      fontFamily:section2headerfont,fontSize:section2headerfontsize}}>{section2header}</h1>

        <p className='black-section-para'style={{textAlign:'center',fontSize:section2parafontsize,
          color:section2parafontcolor,fontFamily:section2parafont,}}>{para2text}</p>
        
      </div>
    </div>
    <Section animation={section7animation}>
    {section7 ? (
      <div className="swipercard-container"  style={{backgroundColor:section7background,padding:20}}>
      <Swiper
      modules={[Autoplay, Navigation, Pagination, EffectCoverflow,Zoom]} // Register modules here
      effect="coverflow"
      grabCursor={false}
      centeredSlides={true}
      slidesPerView={3}  
      loop={true}
      spaceBetween={-100}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
      }}
      zoom= {{
        maxRatio:3, // Adjust the maximum zoom ratio
      }}
      coverflowEffect={{
        rotate: 50,
    stretch: 0,
    depth: 100,
    modifier: 1,
        slideShadows: true,
        centered: true
      }}
     // pagination={{ clickable: true }}
      >
        {section7.map(item => (
          <SwiperSlide key={item.id}>
             <div key={item.id} className="card-wrapper">
         <div className="swipercard">
           <img src={item.url} alt={`Image ${item.text}`} />
           <div className="swipertext-overlay">
          <p style={{fontSize:section7fontsize,fontFamily:section7font,color:section7fontcolor}}>{item.text}</p>
        </div>
         </div>
       </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
      ) : null}
      </Section>
      <Section animation={section4animation}>
      <div className='section4wrap'  style={{backgroundColor:section3backgroundcolor}}>
     
    <div  //style={{ backgroundImage: `url(${section3image})` }}
    >
      <img className="section4banner" src={section3image}></img>
    </div>
    <div className="section4" style={{backgroundColor:section3backgroundcolor}}>
      <div className="section4-text">
        <h1 style={{fontFamily:section4headerfont,color:section4headerfontcolor,fontSize:section4headerfontsize}}>{section4header}</h1>
        <p style={{fontFamily:section4parafont,color:section4paracolor,fontSize:section4parafontsize}}>{section4para}</p>
        
      </div>
    </div>
    </div>
    </Section>
    
    <Section animation={section5animation}>
    {section5!=[]?(
     <div className={`card-container ${section5.length <= 5 ? 'center' : ''}`} 
     style={{backgroundColor:section5backgroundcolor,
    }}>
     {section5.map(item => (
       <div key={item.id} className="card-wrapper">
         <div className="productcard"  >
           <img style={{height:'100%',borderRadius:8,}} src={item.url} alt={`Image ${item.text}`} />
         </div>
         <h2 className="card-text" 
         style={{fontFamily:section5headerfont,color:section5headercolor,fontSize:section5headerfontsize,
          //fontWeight:'bold'
         }}>{item.text}</h2>
       </div>
     ))}
   </div>):null}
   </Section>
   
   <Section animation={section6animation}>
   <div style={{ position: 'relative', width: '100%',backgroundColor:'transparent' }}>
  <img 
    className="section6" 
    src={section6.Image} 
    style={{ width: '100%', height: 'auto' }} 
    alt="Section Image"
  />
  
  <div 
    className="section6text" 
    style={{
      position: 'absolute', 
      bottom: '20px',  // Positioning 20px above the bottom
      left: '20%',    // Positioning 20px from the left edge
      color: section6headercolor,
      padding: '10px',  // Optional: Add padding around the text
    }}
  >
    <h2  style={{ fontFamily: section6headerfont, fontSize: section6headerfontsize,color:section6headercolor }}>
      {section6.Headertext}
    </h2>
    <p style={{ fontFamily: section6parafont, fontSize: section6parafontsize, color: section6paracolor }}>
      {section6.Paratext}
    </p>
  </div>
</div>
</Section>
{demosectionstatus=='Active'?(
<Section>     
<div className="demo-section-wrapper" style={{
                        padding: '40px 20px',
                        textAlign: 'center',
                        borderRadius: '10px',
                        margin: '40px auto',
                        maxWidth: '800px',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                        backgroundColor: '#333333', // Dark background for the demo section
                    }}>
                      
                      {!showDemoContent ? (
                        <h3 style={{
                            fontSize: demosectionheaderfontsize,
                            fontWeight: 'bold',
                            color: demosectionheadercolor,
                            marginBottom: '30px',
                            fontFamily: demosectionheaderfont,
                        }}>
                            {demosectionheader}
                        </h3>):null}

                        {!showDemoContent ? (
                            <button
                                onClick={() => setShowDemoContent(true)}
                                style={{
                                    backgroundColor: demosectionbuttoncolor,
                                    color: demosectionbuttontextcolor,
                                    padding: '15px 30px',
                                    border: 'none',
                                    borderRadius: '10px',
                                    fontSize: demosectionbuttontextfontsize,
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s ease, transform 0.2s ease',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                    fontFamily:demosectionbuttontextfont
                                    // Add hover effect if not using Tailwind's ':hover'
                                    // ':hover': { backgroundColor: '#c02c7a', transform: 'translateY(-2px)' }
                                }}
                            >
                                {demosectionbuttontext}
                            </button>
                        ) : (
  <div className="demo-section" style={{
           // backgroundColor: '#f8f8f8',
            padding: '40px 20px',
            textAlign: 'center',
            borderRadius: '10px',
            margin: '40px auto',
            maxWidth: '800px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
        }}>
            <h3 style={{
                fontSize: demosectionheaderfontsize,
                fontWeight: 'bold',
                color: demosectionheadercolor,
                marginBottom: '30px',
                fontFamily:demosectionheaderfont,
                

            }}>
                {demosectionheader}
            </h3>

            <div className="demo-options-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '20px',
                marginTop: '30px',
                marginBottom: '30px'
            }}>
                {/* Fabric Color */}
                <div className="demo-option-group" style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left',
                    border: activeStep === 0 ? '2px solid #d73688' : '2px solid transparent',
                    borderRadius: '8px',
                    padding: '10px',
                    transition: 'border 0.3s ease-in-out',
                    opacity: activeStep >= 0 ? 1 : 0.5, // Dim if not active
                    pointerEvents: activeStep >= 0 ? 'auto' : 'none' // Disable clicks if not active
                }}>
                    <label htmlFor="fabricColor" style={{ fontWeight: 'bold', marginBottom: '8px', color: '#d73688' }}>Fabric Color:</label>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        {fabricColorsOptions.map(option => (
                            <div
                                key={option.name}
                                onClick={() => handleOptionSelect(setFabricColor, option.name, 0, 1)}
                                title={option.name}
                                style={{
                                    width: '30px',
                                    height: '30px',
                                    borderRadius: '50%',
                                    backgroundColor: option.hex,
                                    cursor: 'pointer',
                                    border: fabricColor === option.name ? '3px solid #007bff' : '1px solid #ccc',
                                    boxShadow: fabricColor === option.name ? '0 0 0 2px rgba(0, 123, 255, 0.5)' : 'none',
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            />
                        ))}
                        ...
                    </div>
                </div>

                {/* Embroidery Type */}
                <div className="demo-option-group" style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left',
                    border: activeStep === 1 ? '2px solid #d73688' : '2px solid transparent',
                    borderRadius: '8px',
                    padding: '10px',
                    transition: 'border 0.3s ease-in-out',
                    opacity: activeStep >= 1 ? 1 : 0.5, // Dim if not active
                    pointerEvents: activeStep >= 1 ? 'auto' : 'none' // Disable clicks if not active
                }}>
                    <label htmlFor="embroideryType" style={{ fontWeight: 'bold', marginBottom: '8px', color: '#d73688' }}>Embroidery Type:</label>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {embroideryTypesOptions.map(option => (
                            <div
                                key={option}
                                onClick={() => handleOptionSelect(setEmbroideryType, option, 1, 2)}
                                style={{
                                    padding: '8px 15px',
                                    borderRadius: '20px',
                                    border: embroideryType === option ? '2px solid #007bff' : '1px solid #ccc',
                                    backgroundColor: embroideryType === option ? '#e0f2ff' : 'white',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem',
                                    color: '#333',
                                    transition: 'all 0.2s ease-in-out',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {option}
                            </div>
                        ))}
                        ...
                    </div>
                </div>

                {/* Embroidery Color */}
                <div className="demo-option-group" style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left',
                    border: activeStep === 2 ? '2px solid #d73688' : '2px solid transparent',
                    borderRadius: '8px',
                    padding: '10px',
                    transition: 'border 0.3s ease-in-out',
                    opacity: activeStep >= 2 ? 1 : 0.5, // Dim if not active
                    pointerEvents: activeStep >= 2 ? 'auto' : 'none' // Disable clicks if not active
                }}>
                    <label htmlFor="embroideryColor" style={{ fontWeight: 'bold', marginBottom: '8px', color: '#d73688' }}>Embroidery Color:</label>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        {embroideryColorsOptions.map(option => (
                            <div
                                key={option.name}
                                onClick={() => handleOptionSelect(setEmbroideryColor, option.name, 2, 3)}
                                title={option.name}
                                style={{
                                    width: '30px',
                                    height: '30px',
                                    borderRadius: '50%',
                                    backgroundColor: option.hex,
                                    cursor: 'pointer',
                                    border: embroideryColor === option.name ? '3px solid #007bff' : '1px solid #ccc',
                                    boxShadow: embroideryColor === option.name ? '0 0 0 2px rgba(0, 123, 255, 0.5)' : 'none',
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            />
                        ))}
                        ...
                    </div>
                </div>

                {/* Design Idea */}
                <div className="demo-option-group" style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left',
                    border: activeStep === 3 ? '2px solid #d73688' : '2px solid transparent',
                    borderRadius: '8px',
                    padding: '10px',
                    transition: 'border 0.3s ease-in-out',
                    opacity: activeStep >= 3 ? 1 : 0.5, // Dim if not active
                    pointerEvents: activeStep >= 3 ? 'auto' : 'none' // Disable clicks if not active
                }}>
                    <label htmlFor="designIdea" style={{ fontWeight: 'bold', marginBottom: '8px', color: '#d73688' }}>Design Idea:</label>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {designIdeasOptions.map(option => (
                            <div
                                key={option}
                                onClick={() => handleOptionSelect(setDesignIdea, option, 3, 4)}
                                style={{
                                    padding: '8px 15px',
                                    borderRadius: '20px',
                                    border: designIdea === option ? '2px solid #007bff' : '1px solid #ccc',
                                    backgroundColor: designIdea === option ? '#e0f2ff' : 'white',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem',
                                    color: '#333',
                                    transition: 'all 0.2s ease-in-out',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {option}
                            </div>
                        ))}
                        ...
                    </div>
                </div>

                {/* Embroidery Position */}
                <div className="demo-option-group" style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left',
                    border: activeStep === 4 ? '2px solid #d73688' : '2px solid transparent',
                    borderRadius: '8px',
                    padding: '10px',
                    transition: 'border 0.3s ease-in-out',
                    opacity: activeStep >= 4 ? 1 : 0.5, // Dim if not active
                    pointerEvents: activeStep >= 4 ? 'auto' : 'none' // Disable clicks if not active
                }}>
                    <label htmlFor="embroideryPosition" style={{ fontWeight: 'bold', marginBottom: '8px', color: '#d73688' }}>Embroidery Position:</label>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {embroideryPositionsOptions.map(option => (
                            <div
                                key={option}
                                onClick={() => handleOptionSelect(setEmbroideryPosition, option, 4, 5)}
                                style={{
                                    padding: '8px 15px',
                                    borderRadius: '20px',
                                    border: embroideryPosition === option ? '2px solid #007bff' : '1px solid #ccc',
                                    backgroundColor: embroideryPosition === option ? '#e0f2ff' : 'white',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem',
                                    color: '#333',
                                    transition: 'all 0.2s ease-in-out',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {option}
                            </div>
                        ))}
                        ...
                    </div>
                </div>
                
            </div>
                          <div>
                          <p style={{
                        marginTop: '15px',
                        fontSize: '1rem',
                        color: 'white',
                        fontStyle: 'italic'
                    }}>
                        Try more design ideas, patterns and colours inside our app
                    </p>
                    <button
                     onClick={()=>handleRedirect()}
                     style={{
                        marginTop: '15px',
                        fontSize: '1rem',
                        color: 'white',
                        fontStyle: 'italic',
                        textDecoration:'underline',
                        background:'transparent',
                        marginBottom:'15px',
                        borderColor:'transparent',
                        cursor: 'pointer',
                    }}>
                        Click here to download our app
                    </button>
                          </div>
            <button
                onClick={handleGenerateDesign}
                className="demo-generate-button"
                disabled={!isGenerateButtonEnabled} // Disable if not all options are selected
                style={{
                    backgroundColor: isGenerateButtonEnabled ? '#d73688' : '#cccccc', // Change color when disabled
                    color: 'white',
                    padding: '12px 25px',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1.1rem',
                    fontWeight: 'bold',
                    cursor: isGenerateButtonEnabled ? 'pointer' : 'not-allowed', // Change cursor
                    transition: 'background-color 0.3s ease',
                    marginTop: '20px',
                    border: activeStep === 5 && !generatedImage ? '2px solid #d73688' : '2px solid transparent', // Highlight generate button
                }}
            >
                Generate Design
            </button>

            {generatedImage && (
                <div className="generated-image-container" ref={imageContainerRef} style={{
                    marginTop: '40px',
                    border: '1px solid #eee',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
                }}>
                    <img src={generatedImage} alt="Generated Design" style={{
                        maxWidth: '100%',
                        height: 'auto',
                        display: 'block',
                        borderRadius: '8px'
                    }} />
                     <p style={{
                        marginTop: '15px',
                        fontSize: '1rem',
                        color: 'white',
                        fontStyle: 'italic'
                    }}>
                        Try more design ideas, patterns and colours inside our app
                    </p>
                    <button
                     onClick={()=>handleRedirect()}
                     style={{
                        marginTop: '15px',
                        fontSize: '1rem',
                        color: 'white',
                        fontStyle: 'italic',
                        textDecoration:'underline',
                        background:'transparent',
                        marginBottom:'15px',
                        borderColor:'transparent',
                        cursor: 'pointer',
                    }}>
                        Click here to download our app
                    </button>
                </div>
            )}
            </div> 
          )}
          </div>
            </Section>
            ):null}
<Section animation={section6animation}>
  
{embedHtml!=''?(
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
            <div
                className="instagram-embed-container"
                style={{ maxWidth: '540px', width: '100%' }} // Keep max-width for responsiveness
                dangerouslySetInnerHTML={{ __html: embedHtml }}
            />
        </div>):null}
        </Section>
  <div className='registration' style={{backgroundColor:section8background}}>
  <img className='goldiesimg' src={goldeisimg}></img>
   
  <template>
    < h2 className='regheader' style={{fontSize:regheaderfontsize,fontFamily:section8headerfont,color:section8headercolor}}>{regheader}
    </h2>
    <p className='regtext' style={{fontSize:regtextfontsize,fontFamily:section8parafont,
      color:section8paracolor}}>{regtext}</p>
  {successalert==true?(<Alert
    intent="success"
    title='Download the app and order now'
    marginTop={10}
    marginLeft={'15%'}
    width={'65%'}
  />):null}
        {imageload==false?(
         
      <div className='inputs'>
        <div style={{flexDirection:'row',borderColor:'#e75600'}}>
      <TextInput
        value={email}
        onChange={onemailchange}
        onBlur={onemailend}
        placeholder={email?email:'Email'}
        style={{backgroundColor:'black',color:'white',borderColor:'#e75600'}}
      /> <br></br>
     
      </div>
      
    </div>):null} 

     {imageload==false&&referalcodeinput==true?(
         
         <div className='inputs'>
           <div style={{flexDirection:'row',borderColor:'#e75600'}}>
         <TextInput
           value={referalcode}
           onChange={onreferallcodechange}
           placeholder={referalcode?referalcode:'Referal code'}
           style={{backgroundColor:'black',color:'white',borderColor:'#e75600'}}
         /> <br></br>
        
         </div>
         
       </div>):(<div className='inputs' >
        <Button onClick={referalcodeinputview} style={{backgroundColor:'transparent',borderColor:'transparent'}}>
       {section1.Popupreferraltext?(<span style={{color:'#e75600',fontSize:21}} > &#10753;&nbsp;</span>):null}
       <span style={{color:'white',fontSize:14,color:section8reftextcolor}}>{section1.Popupreferraltext}</span> 
       </Button>
       </div>)}
    {imageload==false?(
    <div style={{justifyContent:'center',alignItems:'center'}}>
         <Button className="submitbutton" style={{backgroundColor:'#e75600',color:'white',borderRadius:20,
        marginTop:15,fontSize:14,height:24,fontWeight:'bold',borderColor:'#e75600',width:270,}}
         onClick={submit}>{buttontext.toLocaleUpperCase()}
         <img id="weburl" style={{borderRadius:20}} src={userimg} className='userimage' ></img>
     
         </Button>
      
    </div>):null}
    {errormessage!=''?(
    <Alert
    intent="danger"
    title={errormessage}
    width={'65%'}
    fontWeight={'bold'}
    textAlign={'center'}
    marginTop={10}
  />):null}
  </template>
  <div style={{marginTop:10}}>
  <h1 style={{ fontSize: section8invitefontsize, fontFamily: section8invitefont, color: section8invitetextcolor, 
    textAlign: "center" }}>
    {section8invitetext}
  </h1>
  <h5 className='invitepara' style={{ fontSize: section8inviteparafontsize, fontFamily: section8inviteparafont, color: section8inviteparacolor, 
    textAlign: "center" ,}}>
    {section8invitepara}
  </h5>
  <h5 style={{ textAlign: "center" }}>
    <a href="https://play.google.com/store/apps/details?id=com.indreamer.jiffybook">
      <img
        width="200"
        src="https://firebasestorage.googleapis.com/v0/b/jiffybook-public.appspot.com/o/jiffybook.indreamer.com%2Fplay-store-badge.png?alt=media&token=191b000c-08b5-4238-aa03-a8400755351d"
        alt="Play Store Badge"
      />
    </a>
    <br />
    <a href="https://apps.apple.com/app/id1514749994">
      <img
        width="200"
        src="https://firebasestorage.googleapis.com/v0/b/jiffybook-public.appspot.com/o/jiffybook.indreamer.com%2Fapp-store-badge.png?alt=media&token=28b3781e-4eff-4314-8919-dd485f4e9949"
        alt="App Store Badge"
      />
    </a>
  </h5>
</div>
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
  {section9.Contacttext || section9.Socialmediatext ? (
    <div style={{ flexDirection: 'row', display: 'flex', width: 'fit-content' }}>
      {section9.Contacttext && (
        <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span
            style={{
              color: section9.Contacttextcolor,
              textAlign: 'center',
              fontSize: section9.Contactfontsize,
              fontFamily: section9.Contactfont,
              fontWeight: 'bold',
            }}
          >
            {section9.Contacttext}
          </span>

          <div style={{ flexDirection: 'row', marginTop: 5, justifyContent: 'center' }}>
            {busphone ? (
              <a href={`tel:${busphone}`} style={{ fontSize: section9.Iconsize, color: section9.Phoneiconcolor }}>
                <FontAwesomeIcon icon={faPhone} className="iconstyle" />
              </a>
            ) : null}
            {busmail ? (
              <a href={`mailto:${busmail}`} style={{ fontSize: section9.Iconsize, color: section9.Emailiconcolor }}>
                <FontAwesomeIcon icon={faEnvelope} className="iconstyle" />
              </a>
            ) : null}
            {section9.Whatsapp ? (
              <a href={section9.Whatsapp} style={{ fontSize: section9.Iconsize, color: section9.Whatsappiconcolor }}>
                <FontAwesomeIcon icon={faWhatsapp} className="iconstyle" />
              </a>
            ) : null}
          </div>
        </div>
      )}

      {section9.Socialmediatext && (
        <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', marginLeft: section9.Contacttext ? 60 : 0, alignItems: 'center' }}>
          <span
            style={{
              color: section9.Socialmediatextcolor,
              fontFamily: section9.Socialmediafont,
              fontSize: section9.Socialmediatextfontsize,
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {section9.Socialmediatext}
          </span>
          <div style={{ flexDirection: 'row', marginTop: 5, justifyContent: 'center' }}>
            {section9.Facebook ? (
              <a
                href={section9.Facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="iconstyle"
                style={{ fontSize: section9.Iconsize, color: section9.Facebookiconcolor }}
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            ) : null}
            {section9.Twitter ? (
              <a
                href={section9.Twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="iconstyle"
                style={{ fontSize: section9.Iconsize, color: section9.Twittericoncolor }}
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
            ) : null}
            {section9.Instagram ? (
              <a
                href={section9.Instagram}
                target="_blank"
                className="iconstyle"
                style={{ fontSize: section9.Iconsize, color: section9.Instagramiconcolor }}
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            ) : null}
            {section9.Youtube ? (
              <a
                href={section9.Youtube}
                target="_blank"
                className="iconstyle"
                style={{ fontSize: section9.Iconsize, color: section9.Youtubeiconcolor }}
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            ) : null}
          </div>
        </div>
      )}
    </div>
  ) : null}
</div>
    {fetcheddata.data?(
    <div style={{marginTop:45,}}>
    <a style={{color:fetcheddata.data.section8.Policytextcolor,fontSize:fetcheddata.data.section8.Policytextsize,
  fontFamily:fetcheddata.data.section8.Policytextfont,textDecoration:'none'}} href={fetcheddata.data.section8.Policyurl}>{fetcheddata.data.section8.Policytext}</a>
    </div> ):null}
 <footer style={{color:section8footertextcolor,fontSize:section8footerfontsize,
  fontFamily:section8footerfont,marginTop:25,marginBottom:35}}>{section8footertext}</footer> 
  </div>
  
  <button className="floating-overlay-button" style={{backgroundColor:section1.Overlaybuttoncolor,
    color:section1.Overlaybuttontextcolor,fontWeight:'bold',
    fontSize:section1.Overlaybuttonfontsize,fontFamily:section1.Overlaybuttonfontfamily}} onClick={()=>handleRedirect()/*() => setShowPopup(true)*/}>
    {section1.Overlaybuttontext}
  </button>
  
  {/* Popup Modal */}
  {showPopup==true? (
    <div className='popup-overlay'>
      <div className='popup' style={{backgroundColor:section8background}}>
     <div className='popupregistration' style={{backgroundColor:section8background}}>
   
       < h2 className='regheader' style={{fontSize:regheaderfontsize,fontFamily:section8headerfont,color:section8headercolor}}>{regheader}
       </h2>
       <p className='regtext' style={{fontSize:regtextfontsize,fontFamily:section8parafont,color:section8paracolor}}>{regtext}</p>
     
           {imageload==false?(
            
         <div className='inputs'>
           <div style={{flexDirection:'row',borderColor:'#e75600'}}>
         <TextInput
           value={email}
           onChange={onemailchange}
           onBlur={onemailend}
           placeholder={email?email:'Email'}
           style={{backgroundColor:'black',color:'white',borderColor:'#e75600'}}
         /> <br></br>
        
         </div>
         
       </div>):null} 
   
        {imageload==false&&referalcodeinput==true?(
            
            <div className='inputs'>
              <div style={{flexDirection:'row',borderColor:'#e75600'}}>
            <TextInput
              value={referalcode}
              onChange={onreferallcodechange}
              placeholder={referalcode?referalcode:'Referal code'}
              style={{backgroundColor:'black',color:'white',borderColor:'#e75600'}}
            /> <br></br>
           
            </div>
            
          </div>):(<div className='inputs' >
           <Button onClick={referalcodeinputview} style={{backgroundColor:'transparent',borderColor:'transparent'}}>
          {section1.Popupreferraltext?(<span style={{color:fetcheddata.data.section8.Referraliconcolor,fontSize:21}} > &#10753;&nbsp;</span>
          ):null}
          <span style={{color:'white',fontSize:14,color:section8reftextcolor}}>{section1.Popupreferraltext}</span> 
          </Button>
          </div>)}
       {imageload==false?(
       <div style={{justifyContent:'center',alignItems:'center'}}>
            <Button className="submitbutton" style={{backgroundColor:fetcheddata.data.section8.Registerbuttoncolor,
            color:fetcheddata.data.section8.Registerbuttontextcolor,borderRadius:20,
           marginTop:13,fontSize:14,height:24,fontWeight:'bold',borderColor:fetcheddata.data.section8.Registerbuttoncolor,width:270,}}
            onClick={submit}>{fetcheddata.data.section8.Registerbuttontext.toLocaleUpperCase()}
              <FontAwesomeIcon icon={faUserAlt} style={{ color:fetcheddata.data.section8.Registerbuttontextcolor,marginLeft:5,fontSize:12,}}/> 
        
            </Button>
         
       </div>):null}
       {errormessage!=''?(
       <Alert
       intent="danger"
       title={errormessage}
       width={'65%'}
       fontWeight={'bold'}
       textAlign={'center'}
       marginTop={10}
     />):null}
     {successalert==true?(<Alert
       intent="success"
       title='Download the app and order now'
       marginTop={10}
       marginLeft={'0%'}
       width={'85%'}
     />):null}
     {successalert==true?(
     <div style={{marginTop:10}}>
     <h1 style={{ fontSize: section8invitefontsize, fontFamily: section8invitefont, color: section8invitetextcolor, 
       textAlign: "center" }}>
       {section8invitetext}
     </h1>
     <h5 className='invitepara' style={{ fontSize: section8invitefontsize, fontFamily: section8invitefont, color: section8invitetextcolor, 
    textAlign: "center" ,}}>
    {section8invitepara}
  </h5>
     <h5 style={{ textAlign: "center",marginTop:-10 }}>
    <a href="https://play.google.com/store/apps/details?id=com.indreamer.jiffybook">
      <img
        width="200"
        src="https://firebasestorage.googleapis.com/v0/b/jiffybook-public.appspot.com/o/jiffybook.indreamer.com%2Fplay-store-badge.png?alt=media&token=191b000c-08b5-4238-aa03-a8400755351d"
        alt="Play Store Badge"
      />
    </a>
    <br />
    <a href="https://apps.apple.com/app/id1514749994">
      <img
        width="200"
        src="https://firebasestorage.googleapis.com/v0/b/jiffybook-public.appspot.com/o/jiffybook.indreamer.com%2Fapp-store-badge.png?alt=media&token=28b3781e-4eff-4314-8919-dd485f4e9949"
        alt="App Store Badge"
      />
    </a>
  </h5>
     </div>
     ):null}
  <button className="floating-overlay-closebutton" onClick={() => setShowPopup(false)}>
      CLOSE
     </button>
   </div>
 </div>
 </div>
  ):null}
  </div>
  
  );
};

export default App;
